const MAX_DETAILS_LENGTH = 500;

const safeStringify = (value) => {
    try {
        return JSON.stringify(value);
    } catch {
        return "";
    }
};

const truncate = (text, maxLen = MAX_DETAILS_LENGTH) => {
    if (!text) return "";
    return text.length > maxLen ? `${text.slice(0, maxLen)}…` : text;
};

const extractFromResponseData = (data) => {
    if (!data) return "";
    if (typeof data === "string") return data;
    if (Array.isArray(data)) return data.filter(Boolean).map(String).join(", ");
    if (typeof data === "object") {
        // Common backend patterns
        if (typeof data.message === "string") return data.message;
        if (Array.isArray(data.message)) return data.message.filter(Boolean).map(String).join(", ");
        if (typeof data.error === "string") return data.error;
        if (Array.isArray(data.errors)) {
            return data.errors
                .map((e) => (typeof e === "string" ? e : e?.message || safeStringify(e)))
                .filter(Boolean)
                .join(", ");
        }
        // Fallback: stringify the object, but cap length
        return safeStringify(data);
    }
    return String(data);
};

export const extractMessageFromAxiosError = (error) => {
    const details = extractFromResponseData(error?.response?.data);
    if (details) return truncate(details);
    // Fallback to generic error message (e.g. 'Network Error')
    return truncate(error?.message || "");
};
